import { ACAO_LABEL, STATUS, fmtDateTime } from "@/lib/medicoes";

export default function Timeline({ items = [] }) {
  if (!items.length) return <p className="text-sm text-[#94A3B8]">Sem registros.</p>;
  return (
    <ol className="relative border-l border-[#334155] ml-2 space-y-4" data-testid="medicao-timeline">
      {[...items].reverse().map((t, i) => (
        <li key={i} className="ml-4" data-testid={`timeline-item-${i}`}>
          <span className="absolute -left-1.5 w-3 h-3 rounded-full border-2 border-[#0F172A]"
                style={{ background: STATUS[t.status_para]?.color || "#94A3B8" }} />
          <div className="text-sm font-medium">{ACAO_LABEL[t.acao] || t.acao}</div>
          <div className="text-[11px] text-[#94A3B8]">{fmtDateTime(t.em)} · {t.por_nome || t.por} ({t.role})</div>
          {t.observacao && <div className="text-xs text-[#CBD5E1] mt-1 whitespace-pre-wrap">{t.observacao}</div>}
        </li>
      ))}
    </ol>
  );
}
